import Color from "color";

import { colors } from "@apps/viewer/src/ts/config";

const black = Color(colors.black);
const white = Color(colors.white);

/**
 * Collection of shared configurations within the editor.
 */
export const config = {
    /**
     * Specifies the color to use when rendering icons in the thumbnail area of
     * block previews.
     */
    thumbnailIconColor: black
        .alpha(0.15)
        .toString(),

    /**
     * Specifies the default background color to apply to the thumbnail area of
     * the preview layer.
     */
    thumbnailBgColor: black
        .mix(white, 0.8)
        .toString(),

    /**
     * Specifies a faded out version of the background color, so that we can
     * fade icons out of view.
     */
    thumbnailBgColorFaded: black
        .mix(white, 0.9)
        .alpha(0)
        .toString(),
};
